import React from 'react';
import Box from './Box';
export default function Grid({ children, ...props }) {
    return (React.createElement(Box, Object.assign({ display: "grid" }, props), children));
}
